import { shouldRedirectToLogin } from "../../types/constant";

let tokenProvider = null;

export const setTokenProvider = (provider, loginWithRedirect) => {
  try {
    tokenProvider = provider;
  } catch (err) {
    if (shouldRedirectToLogin(err)) {
      loginWithRedirect();
      return;
    }
  }
  //tokenProvider = provider;
};

export const getAccessToken = async () => {
  if (!tokenProvider) {
    throw new Error("Token provider not initialized");
  }

  return tokenProvider();
};
